// extracted by mini-css-extract-plugin
module.exports = {"link":"_c6b260","item":"_968b55"};